import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCreditPointListing, updateCreditPoint } from "@store/slices/commonId";
import { useDispatch } from "react-redux";
import FullPageLoader from "@common/FullPageLoader";
import { addCurrencyFormatting } from "@src/config/helper";
import secureStorage from "@src/config/encrypt";
import { useLanguage } from "@src/context/LanguageContext";

function RewardModel() {
  const [rewardList, setRewardList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading,setLoading] = useState<boolean>(false)
  const dispatch:any = useDispatch();
  const {translations} = useLanguage();
  let { user_data } = secureStorage.getItem("authAgentUserInfo") || {};

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      setLoading(true);
      const payload: Record<string, number> = {
        user_id: user_data?.user_id,
      };
      const res = await dispatch(getCreditPointListing(payload));
      if (res?.status === 200 && res?.data?.length > 0) {
        setRewardList(res?.data);
        setShowModal(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = async () => {
    const currentItem: Record<string, any> = rewardList[currentIndex];
    setLoading(true);
    try {
      const payload: Record<string, number> = {
        lead_id: currentItem?.lead_id,
      };
      await dispatch(updateCreditPoint(payload));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }

    if (currentIndex < rewardList.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setShowModal(false);
    }
  };

  const currentReward:Record<string,any> = rewardList[currentIndex];

  return (
    <React.Fragment>
    <FullPageLoader show={loading} />
      {showModal  && currentReward && (
        <Modal show={showModal} handleClose={handleClose}>

        <div className="modal-overlay">
         <div className="reward-modal">

          <div className="modal-content">
           
            <p className="reward-text">
              {translations?.REWARD_MODEL?.TITLE} <br />
              <strong>{addCurrencyFormatting(currentReward?.agent_comission_amount)} & {currentReward?.agent_point_amount} {translations?.REWARD_MODEL?.POINTS}</strong> <br />
              {translations?.REWARD_MODEL?.INS}{currentReward?.lead_id}
            </p>
          </div>

          <button onClick={handleClose} className="close-btn-bottom">
            <i className="ic-clearclose"></i>
          </button>

        </div>
        </div>
        </Modal>
      )}
    </React.Fragment>
  );
}

export default RewardModel;
